const formatGTMPayload = ({ payload }) => {
  const formattedPayload = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [property, value] of Object.entries(payload)) {
    formattedPayload[`custom.gtm.${property}`] = value;
  }
  return formattedPayload;
};

/**
 * Helper function for pushing data into the data layer.
 * @param {object} payload - data to be pushed into the data layer
 */
const pushToDataLayer = (payload) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

/**
 * Sets the user ID for the session if available.
 * @param {string | null} id - Unique user ID
 */
export const identify = (id) => {
  pushToDataLayer({
    user_id: id || '',
    event: 'userIdSet',
  });
};

/**
 * Push custom events into the data layer
 * @param {object} payload - Data to be included in event
 * @param {string} type - Type of event, required to be named in GTM configuration
 * @param {boolean} customEvent - whether it's a custom event or not in GTM
 */
export const captureEvent = ({ type, payload, customEvent }) => {
  const formattedTypeForGTM = type.replace(':', '-').replace(/\s/g, '');
  if (!customEvent) {
    pushToDataLayer({
      ...formatGTMPayload({ payload }),
      event: `${formattedTypeForGTM}`,
    });
  } else {
    pushToDataLayer({
      ...payload,
      event: `custom.event.${formattedTypeForGTM}`,
    });
  }
};
